import { isSafari } from '../../../utils/browser';
import { IndexedDBStorageAdapter } from './storage-adapters/indexed-db-storage-adapter';
import { MemoryStorageAdapter } from './storage-adapters/memory-storage-adapter';
import { StorageAdapter } from './storage-adapters/storage-adapter';

function getStorageAdapter(): StorageAdapter {
	return isSafari() ? new MemoryStorageAdapter() : new IndexedDBStorageAdapter();
}

export async function saveFileToBrowserStorage(file: File, type: 'video' | 'poster' = 'video'): Promise<void> {
	return getStorageAdapter().save(file, type);
}

export async function loadFileFromBrowserStorage(type: 'video' | 'poster' = 'video'): Promise<File | null> {
	return getStorageAdapter().load(type);
}

export async function deleteFileFromBrowserStorage(): Promise<void> {
	return getStorageAdapter().delete();
}
